export default __webpack_public_path__ + "static/notaryServicesPicture-cee3bc12ae03b744eb6f837e225a00a4.svg";